module.exports = __webpack_public_path__ + "static/2017-aeta-outreach1-6556f838c9be8b94361e1f97b3354515.jpg";